import { FOUNDERS } from "@/lib/brand";

const tilts = ["-rotate-2", "rotate-1", "-rotate-1"];

export const Founders = () => (
  <section id="founders" className="py-28 bg-[#FAF7F2] relative overflow-hidden" data-testid="founders-section">
    <span className="firefly-dot" style={{ top: "14%", left: "8%" }} />
    <span className="firefly-dot" style={{ top: "70%", left: "92%", animationDelay: "2s" }} />
    <div className="max-w-6xl mx-auto px-6">
      <p className="font-hand text-3xl text-amber-700 -rotate-1">made by three friends</p>
      <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-stone-900 mt-2" data-testid="founders-headline">Three friends, one little idea.</h2>
      <p className="text-base sm:text-lg text-stone-700 leading-relaxed mt-6 max-w-3xl" data-testid="founders-description">
        Little Lantern Club started with a simple thought: what if we made the world feel a little more personal again? A place for handwritten words, little creative surprises and the joy of receiving something made with care. Created by the three of us, Meher, Deepakshi and Kalyani, this is our little way of sending more kindness into the world.
      </p>
      <div className="grid sm:grid-cols-3 gap-10 mt-16">
        {FOUNDERS.map((f, i) => (
          <figure key={f.name} className={`bg-white p-4 pb-6 shadow-[0_18px_40px_-28px_rgba(28,25,23,0.5)] ${tilts[i]} hover:rotate-0 transition-transform duration-300`} data-testid={`founder-${f.name.toLowerCase()}`}>
            <img src={f.img} alt={`Illustration of ${f.name}`} loading="lazy" className="w-full aspect-square object-cover" />
            <figcaption className="font-hand text-3xl text-stone-900 text-center mt-4 flex items-center justify-center gap-2">
              <span className="h-2 w-2 rounded-full bg-amber-300 shadow-[0_0_10px_3px_rgba(250,204,21,0.55)]" />{f.name}
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
